const CONTEXTS = {
  ARTICLE: 'article',
  HUB: 'hub'
};

export { CONTEXTS };
